export function getCloudinaryURL(imageURL: string): string | null {
  if (!imageURL || typeof imageURL !== "string") return null;


  const fileMatch = imageURL.match(/(?<=\/files\/)([\w/-]+\.(?:jpg|jpeg|svg|png|bmp|gif|webp|avif))/i);
  const mediaMatch = imageURL.match(
    /(?<=\/media\/thumbnails\/brand-backgrounds\/)([\w/-]+\.(?:jpg|jpeg|svg|png|bmp|gif|webp|avif))/i
  );

  if (mediaMatch) {
    imageURL = `/${mediaMatch[1]}`;
  } else if (fileMatch) {
    imageURL = `/${fileMatch[1]}`;
  }

  const cloudinaryDistribution = process.env.NEXT_PUBLIC_CLOUDINARY_SECURE_DISTRIBUTION;

  if (imageURL.startsWith("http://") || imageURL.startsWith("https://")) {
    return imageURL;
  }

  if (!imageURL.startsWith("/")) {
    const baseURL = `https://${cloudinaryDistribution}/image/upload/c_limit,w_384/f_auto/q_90/v1/`;
    return baseURL + imageURL;
  }

  const isMedia = !!mediaMatch;
  const folderName = isMedia
    ? process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_NAME_BRAND
    : process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_NAME;

  const baseURL = `https://${cloudinaryDistribution}/image/upload/c_limit,w_384/f_auto/q_auto/v1/${folderName}`;
  const completeUrl = baseURL + imageURL;

  return completeUrl;
}

// Everything up to and including the version segment, whatever transformations precede it.
const CLOUDINARY_DELIVERY_PREFIX = /^https?:\/\/[^/]+\/(?:[^/]+\/)?image\/upload\/(?:[^?#]*?\/)?v\d+\//;

/**
 * Strips the Cloudinary delivery prefix so next-cloudinary receives a bare public ID.
 * The file extension must survive: auto-upload fetches the origin using this exact path.
 */
export function getCloudinaryPublicId(src: string): string {
  return src.replace(CLOUDINARY_DELIVERY_PREFIX, "");
}

/** Maps a Cloudinary public ID back to its Azure origin URL, or undefined if it isn't a mapped folder. */
export function getOriginalImageURL(publicId: string): string | undefined {
  const mappings = [
    [process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_NAME_BRAND, process.env.NEXT_PUBLIC_AZURE_PATH_BRAND],
    [process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_NAME, process.env.NEXT_PUBLIC_AZURE_PATH],
  ];

  for (const [folder, origin] of mappings) {
    if (folder && origin && publicId.startsWith(`${folder}/`)) {
      return `${origin.replace(/\/$/, "")}/${publicId.slice(folder.length + 1)}`;
    }
  }

  return undefined;
}
// export function convertAzuretoCloudinaryUrl(url: string) {
//   const cloudinaryFolderName = process.env.NEXT_PUBLIC_CLOUDINARY_FOLDER_NAME;
//   const cloudinaryDistribution = process.env.NEXT_PUBLIC_CLOUDINARY_SECURE_DISTRIBUTION;
//   const match = url.match(/(?<=\/files\/)([\w/-]+\.jpg)/);
//   let imageURL = "";

//   if (match) {
//     imageURL = match[1];
//   }

//   const baseCloudinaryURL = `https://${cloudinaryDistribution}/image/upload/c_limit,w_384/f_auto/q_95/v1/${cloudinaryFolderName}`;
//   let completeUrl = baseCloudinaryURL + "/" + imageURL;

//   return imageURL === "" ? url : completeUrl;

// }
  